import React, { PureComponent } from "react";

class Error extends PureComponent {
  render() {
    const { backErrors, field, className, children } = this.props;

    const visibleBackEndErrors = (backErrors, field) =>
      backErrors && backErrors[field] ? (
        <span className={className} key={backErrors[field]}>
          {backErrors[field]}
        </span>
      ) : (
        ""
      );

    return (
      <div>
        {visibleBackEndErrors(backErrors, field) || (
          <span className={className}>{children}</span>
        )}
      </div>
    );
  }
}

export default Error;
